import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

// Components
import CompanyMatrixTile from './company-matrix-tile';

const CompanyMatrix = ({ tiles }) => {
  const renderedTiles = _.map(tiles, (tile, title) => (
    <CompanyMatrixTile {...tile} key={`item-${title}`} />
  ));

  return (
    <div>
      <div
        className={classNames([
          'matrix__container',
          classes('margin-horizontal-auto'),
          classes('padding-vertical-0'),
          classes('padding-horizontal-3'),
          classes('padding-horizontal-0--wide'),
          classes('display-flex--wide'),
          classes('flex-direction-row--wide'),
          classes('flex-wrap--wide'),
        ])}
      >
        {renderedTiles}
      </div>
    </div>
  );
};

CompanyMatrix.displayName = 'Company Matrix';

CompanyMatrix.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.shape(CompanyMatrix.propTypes)),
  className: PropTypes.string,
  title: PropTypes.string,
};

export default CompanyMatrix;
